<template>
    <div>
        <o-table ref="tableList" :enable-delete="false"
                 :enable-new="false" :enable-view="false" default-sort-by="email" :enable-edit="false" :title="$t('sandoz.cp_logins')"
                 :url="'/api/customer-logins?include=external_ids,external_ids.org_contact'"
                 :extra-row-button="[{icon: 'arrow-right'}]">
            <template slot="filter">
                <o-filter v-on:filter-updated="(filters) => $refs.tableList.setFilters(filters)" :filter-cacheable="true">
                    <o-filter-text :title="$t('sandoz.customer_external_id')" column="external_id"></o-filter-text>
                    <o-filter-text :title="$t('core.first_name')" column="first_name"></o-filter-text>
                    <o-filter-text :title="$t('sandoz.last_name')" column="last_name"></o-filter-text>
                    <o-filter-text :title="$t('sandoz.language')" column="locale"></o-filter-text>
                    <o-filter-text :title="$t('sandoz.user_email')" column="email"></o-filter-text>
                    <o-filter-checkbox class="sales-reps" :items="salesPersons" :title="$t('sandoz.responsible_sales_person')" column="sales_person"></o-filter-checkbox>
                </o-filter>
            </template>
            <template slot="head">
                <o-table-header column="email" :sortable="false">{{ $t('core.email') }}</o-table-header>
                <o-table-header column="first_name" :sortable="false">{{ $t('core.first_name') }}</o-table-header>
                <o-table-header column="last_name" :sortable="false">{{ $t('sandoz.last_name') }}</o-table-header>
                <o-table-header column="locale" :sortable="false">{{ $t('sandoz.language') }}</o-table-header>
                <o-table-header column="external_id" :sortable="false">{{ $t('sandoz.external_ids') }}</o-table-header>
            </template>
            <template slot="body" slot-scope="props">
                <td>{{props.item.email}}</td>
                <td>{{props.item.first_name}}</td>
                <td>{{props.item.last_name}}</td>
                <td>{{props.item.locale}}</td>
                <td>
                    <table class="table table-borderless">
                        <tr v-for="externalId in props.item.external_ids.data">
                            <td width="120">{{externalId.external_id}}</td>
                            <td width="120">{{externalId.status}}</td>
                            <td>{{externalId.org_contact.data.full_name}}</td>
                            <td class="text-right">
                                <b-btn variant="text" size="sm" @click.prevent="$router.push({name: 'customers.detail', params: {id: externalId.org_contact.data.id_contact}})">
                                    <fa icon="arrow-right"/>
                                </b-btn>
                            </td>
                        </tr>
                    </table>
                </td>
            </template>
            <template slot="body-controls" slot-scope="props">
                <td class="text-right">

                </td>
            </template>
        </o-table>

    </div>
</template>

<style scope>
.sales-reps ul {
    width: 250px;
}
.badge-optional-missing {
    color: #212529;
    background-color: #fdf5dd;
    border-radius: 0.125rem;
    display: inline-block;
    padding: 0.25em 0.4em;
    font-size: 75%;
    font-weight: 700;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
}
.badge-mandatory-missing {
    color: #212529;
    background-color: #ffdcda;
    border-radius: 0.125rem;
    display: inline-block;
    padding: 0.25em 0.4em;
    font-size: 75%;
    font-weight: 700;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
}
</style>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
    data: () => ({
        salesPersons: []
    }),
    computed: {
        ...mapGetters({
            user: 'auth/user'
        })
    },
    created () {

    },
    mounted() {
        this.getContractSalesPerson()
    },
    methods: {
        getContractSalesPerson () {
            var self = this
            axios.get('/api/verifications/contract_sales_persons').then((response) => {
                if (response.data.length) {
                    response.data.forEach(function (person) {
                        self.salesPersons.push({ value: person, text: person })
                    })
                }
            }).catch((error) => {
                console.error(error)
            })
        }
    }
}
</script>

